import {controller, target} from '@github/catalyst'

@controller('job-annotations')
class JobAnnotationsElement extends HTMLElement {
  @target declare closeButton: HTMLElement
  @target declare openButton: HTMLElement
  @target declare bodyContainer: HTMLElement

  close() {
    this.bodyContainer.hidden = true
    this.closeButton.hidden = true
    this.openButton.hidden = false
  }

  open() {
    this.bodyContainer.hidden = false
    this.closeButton.hidden = false
    this.openButton.hidden = true
  }
}
